/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 * @description constants
 */

export const NOT_NOW = 'Not now'
export const USE_THE_APP = 'Use the app'
export const ZUMPER = 'Zumper'
export const HEADLINE = 'Stop searching, start finding.'

// firebase link constants
export const DOMAIN = 'https://dt5a9.app.goo.gl/'
export const DOMAIN_TEST = 'https://hbk7j.app.goo.gl/'
export const PACKAGE_NAME = 'com.zumper.rentals'
export const PACKAGE_NAME_TEST = 'com.zumper.rentals.stage'
export const BUNDLE_ID = 'com.zumper.Rentals'
export const BUNDLE_ID_TEST = 'com.zumper.Rentals-test'
export const APP_STORE_ID = '678683201'
export const APP_STORE_ID_TEST = '940197964'
export const MT_VALUE = '8'
export const PT_VALUE = '1870841'
export const EFR_VALUE = '1'

export const BANNER_SUFFIXES = {
  IOS_MWEB_BANNER_SUFFIX: 'ios_mweb_banner',
  IOS_MWEB_RENTER_BANNER_SUFFIX: 'ios_comms_mweb_banner',
} as const

export const BANNER_TYPE = {
  DETAIL: 'DETAIL',
  GALLERY: 'GALLERY',
  APP: 'APP',
  HOMEPAGE: 'HOMEPAGE',
  SEARCH: 'SEARCH',
  MESSAGING: 'MESSAGING',
} as const

export const DETAIL_BANNER_UTM = 'app_banner_detail'
export const HOME_BANNER_UTM = 'app_banner_home'
export const DETAIL_GALLERY_BANNER_UTM = 'app_banner_detail_gallery'
export const SEARCH_BANNER_UTM = 'app_banner_search'
export const MESSAGE_BANNER_UTM = 'app_banner_message'
export const APP_BANNER_UTM = 'app_banner_app'

export const LINK = 'link'
export const APN = 'apn'
export const IBI = 'ibi'
export const ISI = 'isi'
export const MT = 'mt'
export const CT = 'ct'
export const PT = 'pt'
export const EFR = 'efr'
export const UTM = 'utm_source'
